import Service from '@ember/service';

import { getOwner } from '@ember/owner';
import Route from '@ember/routing/route';
import { DEBUG } from '@glimmer/env';
import { decorateClass, isClassDecoratorArgs, isDecoratorArgs } from 'decorator-setup';
import { tracked } from 'tracked-built-ins';

/**
 * Define a route model for the purposes of not-found-error display
 * @param {string|{name:string,}} model
 * @returns {function(*): *}
 */
export function pageNotFoundModel(model) {
  const isFactory = !(isDecoratorArgs(...arguments));
  if (!isFactory || !model) {
    throw new Error('@pageNotFoundModel decorator expects a model');
  }
  return function(Target) {
    if (!Route.isPrototypeOf(Target)) {
      throw new Error('@pageNotFoundModel decorator should be applied to an Ember Route derived class');
    }
    return decorateClass(class PageNotFoundModelDecoratedRoute extends Target {
      beforeModel() {
        super.beforeModel(...arguments);
        getOwner(this).lookup('service:page-not-found-model').setModel(model);
      }
      resetController(controller, isExiting, transition) {
        super.resetController(...arguments);
        if (isExiting) {
          getOwner(this).lookup('service:page-not-found-model').setModel(null);
        }
      }
    });
  };
}

export default class PageNotFoundModelService extends Service {
  @tracked model = null;
  setModel(model = null) {
    this.model = !model ? null : typeof model === 'string' ? { name: model } : { ...model };
  }
}
